import makeStyles from '@mui/styles/makeStyles'
import Typography from '@mui/material/Typography'
import BillboardAd from 'components/BillboardAd'
import Layout from 'components/Layout'
import { MoreShowsButton } from 'components/MoreShowsButton'
import SearchResult from 'components/SearchResult'
import BreadcrumbShowJsonLd from 'components/seo/BreadcrumbShowJsonLd'
import WebpageJsonLd from 'components/seo/WebpageJsonLd'
import ShowDetails from 'components/ShowDetails'
import { MORE_SHOWS_AMOUNT, SORT_DATE_TITLE_DESC } from 'lib/constants'
import { getShow, getShows } from 'lib/shows'
import { caching, getImageURL } from 'lib/utils'
import Head from 'next/head'

const useStyles = makeStyles((theme) => ({
  current: {
    marginBottom: theme.spacing(7)
  },
  adContainer: {
    marginBottom: theme.spacing(3)
  }
}))

export default function Show ({ show, moreShows, hasMore }) {
  const classes = useStyles()
  const title = `Sendung verpasst? ${show.fullTitle} vom ${show.date} (${show.stations[0].name})`

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name='description' content={show.description} />
      </Head>
      <WebpageJsonLd name={show.fullTitle} description={show.description} image={getImageURL(show.image, show.stations[0].slug)} />
      <BreadcrumbShowJsonLd show={show} />

      <Layout>
        <BillboardAd slot={process.env.NEXT_PUBLIC_ADSENSE_SLOT_SHOW_DETAILS} className={classes.adContainer} />
        <section className={classes.current}>
          <ShowDetails show={show} />
        </section>

        {moreShows &&
          <section className={classes.more}>
            <Typography component='h2' variant='h2' gutterBottom>Weitere Folgen</Typography>
            <div className={classes.moreContent} data-test='more-videos'>
              {moreShows.map((show) => (
                <div key={show._id} className={classes.card}>
                  <SearchResult result={show} lazy />
                </div>
              ))}
              {hasMore &&
                <MoreShowsButton series={show.series.name} />}
            </div>
          </section>}

      </Layout>
    </>
  )
}

export async function getServerSideProps ({ query, res }) {
  caching(res, process.env.CACHE_VIDEO)

  const slug = query.slug
  if (!slug) {
    return { notFound: true }
  }

  const show = await getShow({ slug })
  if (!show) {
    return { notFound: true }
  }

  let moreShows = null
  let hasMore = false
  if (show.series && show.series.slug) {
    const dbMoreShows = await getShows({ series: show.series.slug, sort: SORT_DATE_TITLE_DESC })
    const nrOfShows = dbMoreShows.hits.total.value
    if (nrOfShows > 1) {
      moreShows = dbMoreShows.hits.hits.filter(item => item._id !== show.id)
    }
    if (nrOfShows > MORE_SHOWS_AMOUNT) {
      hasMore = true
    }
  }

  return {
    props: {
      show,
      moreShows,
      hasMore
    }
  }
}
